





























import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import FlexGridTableMainRow from '@/components/base/flex-grid/table/FlexGridTableMainRow.vue';
import FlexGridModel, {GroupRow, SubcomponentRow} from '@/models/FlexGridModel';
import FlexGridTableRowTypeEnum from '@/enums/FlexGridTableRowTypeEnum';

@Component({
    components: {FlexGridTableMainRow},
})
export default class FlexGridTableGroupRow extends Vue {
    @Prop() info!: GroupRow;
    @Inject() moduleName!: string;
    @Inject() selectable!: boolean;

    get mainData(): FlexGridModel | null {
        return this.$store.state[this.moduleName].data;
    }
    get isEditable(): number {
        return this.$store.state[this.moduleName].isEditable;
    }

    get groupColspan(): number {
        return this.$store.getters[`${this.moduleName}/groupColspan`];
    }

    get emptyCellsCount(): number {
        return this.$store.getters[`${this.moduleName}/emptyCellsCount`] + Number(this.selectable);
    }

    get trStyle() {
        return {
            display: this.info.show ? null : 'none',
            'background-color': '#eeeeee',
        };
    }

    onToggleBtnClick(bool: boolean) {
        this.info.isOpen = bool;
        if (bool && this.info.childsData) {
            let skipUntilIndex: number | null = null;
            for (let i = 0; i < this.info.childsData.items.length; i++) {
                let row = this.info.childsData.items[i];
                if (row.type === FlexGridTableRowTypeEnum.Group && !(row as GroupRow).isOpen) {
                    skipUntilIndex = (row as any).childsData.endIndex;
                    row.show = bool;
                } else if (
                    (row.type === FlexGridTableRowTypeEnum.Subcomponent && !(row as SubcomponentRow).main?.isOpen) ||
                    (typeof skipUntilIndex === 'number' && skipUntilIndex > i)
                ) {
                    continue;
                } else {
                    skipUntilIndex = null;
                    row.show = bool;
                }
            }
        } else {
            this.info.childsData?.items.forEach(item => (item.show = bool));
        }
    }
}
